import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

const SelectCustomized = ({
  label,
  options,
  onChange,
  value,
  width = null,
  height = 40,
  error = null,
  obligatoire = false,
  labelSize = 15,
  disabled = false,
  ...restProps
}) => {
  const theme = useTheme();

  const borderStyles = {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
      "&:hover fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
      "&.Mui-focused fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.primary.main,
    },
  };

  const handleSelectChange = (event) => {
    onChange(event.target.value || "");
  };

  const handleClear = () => {
    onChange("");
  };

  return (
    <Box>
      <Typography
        gutterBottom
        color="primary.main"
        style={{
          marginLeft: 7,
          fontSize: `${labelSize}px`,
        }}
      >
        {label} {obligatoire && <span style={{ color: "red" }}>*</span>}
      </Typography>
      <FormControl
        fullWidth={width === null}
        sx={{
          width: width !== null ? `${width}px` : undefined,
          ...borderStyles,
        }}
      >
        <Select
          value={value}
          onChange={handleSelectChange}
          sx={{
            height: `${height}px`,
            backgroundColor: "#F6F6F6",
            ...borderStyles,
          }}
          error={Boolean(error)}
          MenuProps={{ PaperProps: { sx: { maxHeight: "70%" } } }}
          endAdornment={
            !disabled &&
            value && (
              <InputAdornment
                position="end"
                sx={{ mr: 2, position: "absolute", right: 15 }}
              >
                <IconButton onClick={handleClear} sx={{ padding: 0 }}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            )
          }
          disabled={disabled}
          {...restProps}
        >
          {options.map((option, index) => (
            <MenuItem
              sx={{ maxHeight: "300px" }}
              key={index}
              value={option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default SelectCustomized;
